import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import LinkStyleButton from '@src/components/LinkStyleButton'
import CaretDownIcon from '@src/icons/CaretDownIcon'

const useStyles = makeStyles()((theme) => ({
  icon: {
    fontSize: theme.typography.pxToRem(9),
    marginLeft: theme.spacing(1),
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginTop: theme.spacing(1 / 2),
  },
  iconExpanded: {
    transform: 'rotate(180deg)',
  },
}))

interface TableRowDetailWithExpansionProps {
  isExpanded: boolean
  id: string
  onClick: (e: string) => void
}
const TableRowDetailWithExpansion: React.FC<
  TableRowDetailWithExpansionProps
> = ({ isExpanded, id, onClick }) => {
  const { classes } = useStyles()
  const toggleExpanded = () => {
    onClick(id)
  }
  return (
    <LinkStyleButton onClick={toggleExpanded} aria-expanded={false}>
      <FormattedMessage id="DETAILS" defaultMessage="Details" />

      {isExpanded ? (
        <CaretDownIcon className={clsx(classes.icon, classes.iconExpanded)} />
      ) : (
        <CaretDownIcon className={classes.icon} />
      )}
    </LinkStyleButton>
  )
}
export default TableRowDetailWithExpansion
